import React from "react";
import { LucideIcon } from "lucide-react";
import { IconType } from "react-icons";

interface IntegrationIconProps {
  icon: IconType | LucideIcon | React.ComponentType<{ className?: string }>;
  color?: string;
  bgColor?: string;
  available?: boolean;
  size?: string;
}

export const IntegrationIcon: React.FC<IntegrationIconProps> = ({
  icon: Icon,
  color,
  bgColor,
  available = true,
  size = "h-6 w-6",
}) => {
  const iconColor = available
    ? color || "text-gray-600"
    : "text-gray-400 grayscale";
  const iconBgColor = available ? bgColor || "bg-gray-100" : "bg-gray-100";

  // Use smaller padding for smaller icons
  const padding = size === "h-5 w-5" ? "p-1.5" : "p-2";

  return (
    <div className={`${padding} rounded-lg ${iconBgColor}`}>
      <Icon className={`${size} ${iconColor}`} />
    </div>
  );
};
